import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  TREE_LIST: '/dh-datamaint/subject/listSbjCatalogTree',
  SUIT_LIST: '/dh-datamaint/suitPeople/listAll',
  PAGE: '/dh-datamaint/specimen/page',
  DELETE: '/dh-datamaint/specimen/batchDelete',
  DETAIL: '/dh-datamaint/specimen/getSpecimenInfo',
  UPDATE: '/dh-datamaint/specimen/update',
  BATCH_UPDATE: '/dh-datamaint/specimen/batchUpdate',
  ADD_SUBJECT: '/dh-datamaint/subject/add',
  SUBJECT_LIST: '/dh-datamaint/subject/listByVersionId',
  RELATED_LIST: '/dh-datamaint/specimen/getRelatedResById',
  UPDATE_RELATED: '/dh-datamaint/specimen/relateSpec',
  PAGE_FOR_CHOOSE: '/dh-datamaint/specimen/pageForChoose',
  FOLDER_LIST: '/dh-datamaint/specimen/listImportSpecFolders',
  IMPORT_SPEC: '/dh-datamaint/specimen/importSpec',
  PAGE_IMPORT: '/dh-datamaint/fileImport/page',
  PAGE_IMPORT_ERROR: '/dh-datamaint/fileImportError/page',
  SORT_LIST: '/dh-datamaint/specimen/listSort',
  SORT_SPECIMEN: '/dh-datamaint/specimen/sort',
  SPEC_VIDEO: '/dh-datamaint/specimen/getSpecVideo',
  RELATED_VIDEO: '/dh-datamaint/specimen/relateSpecVideo',
  SPECIMEN_VIDEO_LIST: '/dh-datamaint/courseware/pageSpecVideo',
  SPECIMEN_VIDEO_TREE: '/dh-datamaint/cwSubject/listSbjCatalogTree',
  COPY_SPECIMEN: '/dh-datamaint/specimen/copy'
};

const formatCatalog = function (catalogs: any) {
  let catalogNames = '';

  if (catalogs && catalogs.length > 0) {
    catalogs.forEach((item: any) => {
      catalogNames += item.pathZh + '、';
    })

    catalogNames = catalogNames.substring(0, catalogNames.length - 1);
  }

  return catalogNames;
}

class SpecimenModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getTreeList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.TREE_LIST, { params: payload.data });
    },

    async getSuitList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SUIT_LIST, { params: payload.data });
    },

    async getPage(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.post(URL.PAGE, payload.data,
        { params: { pageNo: payload.data.pageNo, pageSize: payload.data.pageSize } });

      res.data.records.forEach((item: any) => {
        item.pathZh = item.pathZh || '-';
      })

      return res;
    },

    async getSpecimenForChoose(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_FOR_CHOOSE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async BatchUpdate(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.BATCH_UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, payload.data);
    },

    async AddSubject(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD_SUBJECT, payload.data);
    },

    async getSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SUBJECT_LIST, { params: payload.data });
    },

    async getRelatedList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATED_LIST, { params: payload.data });
    },

    async UpdateRelated(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE_RELATED, payload.data);
    },

    async getFolderList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.FOLDER_LIST, { params: payload.data });
    },

    async importSpec(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.IMPORT_SPEC, payload.data);
    },

    async getImRecPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_IMPORT, { params: payload.data });
    },

    async getImErrorPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_IMPORT_ERROR, { params: payload.data });
    },

    async getSortList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SORT_LIST, { params: payload.data });
    },

    async sortSpecimen(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT_SPECIMEN, payload.data);
    },

    async getSpecVideo(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SPEC_VIDEO, { params: payload.data });
    },

    async relatedVideo(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATED_VIDEO, payload.data);
    },

    async getSVTree(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SPECIMEN_VIDEO_TREE, { params: payload.data });
    },

    async getSVList(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.SPECIMEN_VIDEO_LIST, { params: payload.data });
      res.data.records.forEach((item: any) => {
        item.nameEn = item.nameEn || '-';
      })
      return res;
    },

    async copySpecimen(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.COPY_SPECIMEN, payload.data);
    }
  };
}

export const specimenModule = new SpecimenModule();
